import React, {FC, useEffect, useState} from 'react';
import './view.styles.css';
import {PropsType} from "./view.types";
import {SearchModesType} from "./index.types";

const ProcessPendingFilmModalView: FC<PropsType> = ({
      currentPendingFilm,
      processResult,
      searchIds,
      submitPendingFilm,
      skip,
   }: PropsType) => {
    const [titleCustom, setTitleCustom] = useState<string>(currentPendingFilm.title || '')
    const [yearCustom, setYearCustom] = useState<string>(currentPendingFilm.year || '')
    const [filmaCustomId, setFilmaCustomId] = useState<string>(currentPendingFilm.filmaffinityId?.id || '')
    const [imdbCustomId, setImdbCustomId] = useState<string>(currentPendingFilm.imdbId?.id || '')
    const [audioCustom, setAudioCustom] = useState<string>(currentPendingFilm.langs || '')
    const [subsCustom, setSubsCustom] = useState<string>(currentPendingFilm.subs || '')

    // useEffect(() => {
    //     setTitleCustom(currentPendingFilm.title || '')
    //     setYearCustom(currentPendingFilm.year || '')
    //     setAudioCustom(currentPendingFilm.langs || '')
    //     setSubsCustom(currentPendingFilm.subs || '')
    //     setFilmaCustomId(currentPendingFilm.filmaffinityId?.id)
    //     setImdbCustomId(currentPendingFilm.imdbId?.id)
    // }, [currentPendingFilm])

    useEffect(() => {
        setFilmaCustomId(processResult.filmaffinity?.id || currentPendingFilm.filmaffinityId?.id || '')
        setImdbCustomId(processResult.imdb?.id || currentPendingFilm.imdbId?.id || '')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [processResult])

    function onSearch(mode: SearchModesType){
        searchIds(`${titleCustom} ${yearCustom || ''}`.trim(), mode)
    }

    function onSubmit(){
        submitPendingFilm({
            ...currentPendingFilm,
            filmaffinityId: processResult.filmaffinity?.id === filmaCustomId ? processResult.filmaffinity : {id: filmaCustomId},
            imdbId: processResult.imdb?.id === imdbCustomId ? processResult.imdb : {id: imdbCustomId},
            langs: audioCustom,
            subs: subsCustom
        })
    }

    function onSkip(){
        skip()
    }

    return (
        <div className="App">
            <p>
                {currentPendingFilm.filename}
            </p>
                <input type={'text'}
                       placeholder={'title'}
                       value={titleCustom}
                       onChange={(e) => {
                           setTitleCustom(e.target.value)
                       }}/>
                <input type={'text'}
                       placeholder={'year'}
                       value={yearCustom}
                       onChange={(e) => {
                           setYearCustom(e.target.value)
                       }}/>
            <div>
                AUDIO:
                <input type={'text'}
                       placeholder={'audio'}
                       value={audioCustom}
                       onChange={(e) => {
                           setAudioCustom(e.target.value)
                       }}/>
                SUBS:
                <input type={'text'}
                       placeholder={'subs'}
                       value={subsCustom}
                       onChange={(e) => {
                           setSubsCustom(e.target.value)
                       }}/>
            </div>
            <div>
                {processResult.imdb?.title || currentPendingFilm.imdbId?.title || ''}
                <br/>
                <a href={processResult.imdb?.url || currentPendingFilm.filmaffinityId?.url || ''} target={'_blank'} rel="noreferrer">{processResult.imdb?.url || currentPendingFilm.imdbId?.url || ''}</a>
                <br/>
                {processResult.filmaffinity?.title || currentPendingFilm.filmaffinityId?.title || ''}
                <br/>
                <a href={processResult.filmaffinity?.url || currentPendingFilm.filmaffinityId?.url || ''} target={'_blank'} rel="noreferrer">{processResult.filmaffinity?.url || currentPendingFilm.filmaffinityId?.url || ''}</a>
                <br/>
                <input type={'text'}
                       placeholder={'filmaffinity'}
                       value={filmaCustomId}
                       onChange={(e) => {
                           setFilmaCustomId(e.target.value)
                       }}/>
                <input type={'text'}
                       placeholder={'imdb'}
                       value={imdbCustomId}
                       onChange={(e) => {
                           setImdbCustomId(e.target.value)
                       }}/>
            </div>

            <div>
            </div>
            <div>
                <img style={{ width: 100, height: 200 }} alt={"imdb"} src={processResult.imdb?.image || currentPendingFilm.imdbId?.image}/>
                <img style={{ width: 100, height: 200 }} alt={"filmaffinity"} src={processResult.filmaffinity?.image || currentPendingFilm.filmaffinityId?.image}/>
            </div>
            <p>Search:</p>
            <button onClick={() => onSearch("both")}>Search both</button>
            <button onClick={() => onSearch("filmaffinity")}>FilmaffinityID</button>
            <button onClick={() => onSearch("imdb")}>ImdbId</button>
            <p/>
            <p/>
            <button onClick={onSubmit}>Submit</button>
            <button onClick={onSkip}>Skip</button>


            {/*<p>{JSON.stringify(currentPendingFilm)}</p>*/}
        </div>
    );
}

export default ProcessPendingFilmModalView;
